//  by zhangxinxu welcome to visit my personal website http:// www.zhangxinxu.com/
//  zxx.drag v1.0 2010-03-23 元素的拖拽实现
// by yf.wang edit 2017-10-18 加入原始位置输入参数，解决后生成的元素第一次定位问题
var params = {
  left: 0,
  top: 0,
  currentX: 0,
  currentY: 0,
  flag: false
}
// 获取相关CSS属性
var getCss = function (o, key) {
  return o.currentStyle ? o.currentStyle[key] : document.defaultView.getComputedStyle(o, false)[key]
}

// 拖拽的实现
var startDrag = function (size, bar, target, callback) {
  // if (getCss(target, 'left') !== 'auto') {
  //   params.left = getCss(target, 'left')
  // }
  // if (getCss(target, 'top') !== 'auto') {
  //   params.top = getCss(target, 'top')
  // }
  params.left = size.left
  params.top = size.top
  params.currentX = 0
  params.currentY = 0
  var disX = params.currentX
  var disY = params.currentY
  target.style.left = parseInt(params.left) + disX + 'px'
  target.style.top = parseInt(params.top) + disY + 'px'

  if (typeof callback === 'function') {
    var back = (parseInt(params.left) + disX, parseInt(params.top) + disY)
    callback(back)
  }
  // o是移动对象
  bar.onmousedown = function (event) {
    params.flag = true
    if (!event) {
      event = window.event
      // 防止IE文字选中
      bar.onselectstart = function () {
        return false
      }
    }
    var e = event
    params.currentX = e.clientX
    params.currentY = e.clientY
  }
  document.onmouseup = function () {
    params.flag = false
    if (getCss(target, 'left') !== 'auto') {
      params.left = getCss(target, 'left')
    }
    if (getCss(target, 'top') !== 'auto') {
      params.top = getCss(target, 'top')
    }
  }
  document.onmousemove = function (event) {
    // var e = event ? event : window.event
    var e = event || window.event
    if (params.flag) {
      var nowX = e.clientX
      var nowY = e.clientY
      var disX = nowX - params.currentX
      var disY = nowY - params.currentY
      if (parseInt(params.top) + disY < 60) {
        return
      }
      target.style.left = parseInt(params.left) + disX + 'px'
      target.style.top = parseInt(params.top) + disY + 'px'
      if (event.preventDefault) {
        event.preventDefault()
      }
      return false
    }

    if (typeof callback === 'function') {
      var back = (parseInt(params.left) + disX, parseInt(params.top) + disY)
      callback(back)
    }
  }
}
export default startDrag
